import { ChatMemorySource } from '../../../libs/models/ChatMemorySource';

export const validateUrl = (
    url: string,
    setValidationError: (error: string | null) => void,
    resources?: ChatMemorySource[],
): { isValid: boolean; error: string | null } => {
    let error: string | null = null;

    if (!url.trim()) {
        error = 'Please enter a URL';
        setValidationError(error);
        return { isValid: false, error };
    }

    let inputUrl = url.trim();

    if (inputUrl.startsWith('www.') && !inputUrl.includes('://')) {
        inputUrl = `https://${inputUrl}`;
    } else if (!inputUrl.includes('://')) {
        inputUrl = `https://${inputUrl}`;
    }

    let urlObj;
    try {
        urlObj = new URL(inputUrl);

        const hostnameSegments = urlObj.hostname.split('.');
        if (hostnameSegments.length < 2) {
            error = 'Please enter a valid domain with TLD (e.g., example.com)';
            setValidationError(error);
            return { isValid: false, error };
        }

        const validTLDs = [
            'com',
            'org',
            'net',
            'gov',
            'edu',
            'io',
            'co.uk',
            'uk',
            'us',
            'ca',
            'de',
            'fr',
            'au',
            'jp',
            'cn',
            'in',
            'app',
            'dev',
            'ai',
            'info',
            'biz',
            'me',
            'tv',
            'eu',
            'ru',
            'nl',
            'it',
            'es',
            'se',
            'no',
            'fi',
            'dk',
            'ch',
            'at',
            'be',
            'pl',
            'br',
            'mx',
            'ar',
            'cl',
            'za',
            'nz',
            'sg',
            'hk',
            'kr',
            'tw',
            'th',
            'id',
            'my',
            'ph',
            'vn',
            'tr',
            'il',
            'ae',
            'sa',
            'qa',
            'eg',
            'ma',
            'ng',
            'ke',
            'gh',
            'tz',
            'za',
            'mu',
            're',
            'ac.uk',
            'gov.uk',
            'org.uk',
            'me.uk',
            'ltd.uk',
            'plc.uk',
            'net.uk',
            'sch.uk',
            'nhs.uk',
            'ac.jp',
            'co.jp',
            'go.jp',
            'or.jp',
            'ne.jp',
            'ac.za',
            'co.za',
            'org.za',
            'web.za',
            'net.za',
        ];

        const domainParts = hostnameSegments.slice(hostnameSegments[0] === 'www' ? 1 : 0);

        let validTLDFound = false;
        for (let i = 1; i < domainParts.length; i++) {
            const potentialTLD = domainParts.slice(i).join('.');
            if (validTLDs.includes(potentialTLD)) {
                validTLDFound = true;
                break;
            }
        }

        const simpleTLD = domainParts[domainParts.length - 1];
        if (validTLDs.includes(simpleTLD)) {
            validTLDFound = true;
        }

        if (!validTLDFound) {
            error = 'Please enter a valid domain with a recognized TLD';
            setValidationError(error);
            return { isValid: false, error };
        }
    } catch (error) {
        const errorMsg = 'Please enter a valid URL';
        setValidationError(errorMsg);
        return { isValid: false, error: errorMsg };
    }

    if (urlObj.protocol !== 'https:') {
        error = 'URL must use HTTPS for security';
        setValidationError(error);
        return { isValid: false, error };
    }

    if (resources && resources.length > 0) {
        const normalizedInputHost = urlObj.hostname.replace(/^www\./, '').toLowerCase();
        const inputHostWithoutTLD = normalizedInputHost.split('.')[0];

        const matchingResource = resources.find((resource) => {
            const resourceBaseName = resource.name.toLowerCase().replace(/\.pdf$/i, '');

            if (resourceBaseName === inputHostWithoutTLD) {
                return true;
            }

            if (resource.WebAddress) {
                try {
                    const resourceUrl = new URL(resource.WebAddress);
                    const normalizedResourceHost = resourceUrl.hostname.replace(/^www\./, '').toLowerCase();
                    const resourceHostWithoutTLD = normalizedResourceHost.split('.')[0];

                    if (resourceHostWithoutTLD === inputHostWithoutTLD) {
                        return true;
                    }
                } catch {
                    const cleanResourceWebAddress = resource.WebAddress.replace(/^https?:\/\/(www\.)?/, '')
                        .replace(/\/$/, '')
                        .toLowerCase()
                        .split('.')[0];

                    if (cleanResourceWebAddress === inputHostWithoutTLD) {
                        return true;
                    }
                }
            }

            return false;
        });

        if (matchingResource) {
            error = `This URL or domain has already been added under the name ${matchingResource.name}`;
            setValidationError(error);
            return { isValid: false, error };
        }
    }

    setValidationError(null);
    return { isValid: true, error: null };
};
